var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ccos-system__specs-link ccos-link",on:{"click":function($event){return _vm.openSpecs(_vm.system.guid)}}},[_vm._v(" Specificaties tonen ")])}
var staticRenderFns = []

export { render, staticRenderFns }